import { Box } from 'grid'
import {
  DefaultButton,
  Dialog,
  DialogType,
  IDialogProps,
  PrimaryButton,
  Stack,
} from 'office-ui-fabric-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useTheme } from 'theme'

export type ConfirmDeleteDialogProps = Omit<IDialogProps, 'modalProps'> & {
  onConfirm: () => void
  itemCount?: number
}

export const ConfirmDeleteDialog: React.FunctionComponent<
  ConfirmDeleteDialogProps
> = ({ dialogContentProps, itemCount, ...props }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <Dialog
      dialogContentProps={{
        type: DialogType.normal,
        title: t('dialog.confirmDelete.title'),
        subText: t('dialog.confirmDelete.subText', { count: itemCount }),
        ...dialogContentProps,
      }}
      {...props}
      modalProps={{
        isBlocking: true,
        styles: { main: { maxWidth: 450 } },
      }}
    >
      <Box mt={2}>
        <Stack
          tokens={{ childrenGap: theme.space![1] }}
          horizontal={true}
          horizontalAlign="end"
        >
          <Stack.Item>
            <DefaultButton onClick={props.onDismiss as any}>
              {t('action.cancel')}
            </DefaultButton>
          </Stack.Item>
          <Stack.Item>
            <PrimaryButton onClick={props.onConfirm}>
              {t('action.ok')}
            </PrimaryButton>
          </Stack.Item>
        </Stack>
      </Box>
    </Dialog>
  )
}

export default ConfirmDeleteDialog
